/* eslint-disable eqeqeq */
import React, { useState } from "react";
import Spin from "../../components/Spin";
import AuthLeftSide from "../../components/AuthLeftSide";
import { Formik } from "formik";
import { Button } from "../../components/ui/button";
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from "../../components/ui/input-otp";
import { Mail } from "lucide-react";
import { API, get, post } from "../../config";
import { Link, useNavigate } from "react-router-dom";
import { ThemeToggle } from "../../components/ThemeToggle";
import GoogleAuth from "../../assets/images/authenticator.png";
import MicroAuth from "../../assets/images/microsoft-authenticator.png";
import { useOrganization } from "../../lib/context/OrganisationContext";
import FaviconSVG from "../../components/FaviconSVG";
import LogoSVG from "../../components/LogoSVG";
import { useUser } from "../../lib/context/UserContext";

const TwoFactorAuth = ({ change = false, handle2FAChange }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [useMethod, setUseMethod] = useState(false);
  const email = localStorage.getItem("ts-auth-email");
  const tokenExpiredEmail = localStorage.getItem("token-expired-email");
  const DefaultURL = localStorage.getItem("DefaultURL");

  const { updateOrganizationList } = useOrganization();
  const { updateUserData } = useUser();

  const toggleUseMethod = async (setFieldValue) => {
    setFieldValue("code", "");

    if (useMethod === false) {
      setLoading(true);
      const { data } = await post(API.EMAIL_AUTHENTICATION, {
        email: email,
      });
      if (data.status === 200) {
        setLoading(false);
      } else {
        setLoading(false);
      }
      setLoading(false);
    }
    setUseMethod(!useMethod);
  };

  const handleFinish = async (values) => {
    try {
      const email = localStorage.getItem("ts-auth-email");
      const apiURL = useMethod
        ? API.VERIFY_EMAIL_AUTHENTICATION
        : `${API.GOOGLE_2FA_VERIFY}?login=1`;
      const { data } = await post(apiURL, {
        email: email,
        code: values?.code,
      });
      if (data.status === 200) {
        setLoading(true);
        handle2FAChange && handle2FAChange();
        if (!change) {
          const userDetails = await get(API.GET_USER_PROFILE);
          if (userDetails) {
            updateUserData(userDetails?.data?.data);
          }

          let is_subscribe = userDetails?.data?.subscribed;
          let isAMLSubscribe = 0;
          if (userDetails?.data?.data?.user_organizations?.length === 1) {
            isAMLSubscribe =
              userDetails?.data?.data?.user_organizations[0]?.organization
                ?.is_aml_ctf_subscribed;
          }
          let singleTrust = userDetails?.data?.single_trust;
          let singleTrustId = userDetails?.data?.trust_id;

          updateOrganizationList(
            userDetails?.data?.data?.user_organizations &&
              userDetails?.data?.data?.user_organizations?.length > 0
              ? userDetails?.data?.data?.user_organizations?.map((item) => {
                  return {
                    ...item?.organization,
                    value: item?.organization?.id ? item?.organization?.id : "",
                    label: item?.organization?.business_name
                      ? item?.organization?.business_name
                      : "",
                  };
                })
              : [],
          );

          const { first_name, last_name, profile_pic, id, role } =
            userDetails?.data?.data;
          localStorage.setItem(
            "Name",
            first_name ? `${first_name} ${last_name}` : last_name,
          );
          localStorage.setItem("ProfilePhoto", profile_pic);
          localStorage.setItem("role", role?.name);
          localStorage.setItem("roleType", role?.type);
          localStorage.setItem("role-slug", role?.slug);
          localStorage.setItem("userId", id);
          localStorage.setItem("EmailVerification", 1);
          localStorage.setItem("ts-auth-tfa", 2);

          setLoading(false);
          setUseMethod(false);
          tokenExpiredEmail === values?.email
            ? navigate(DefaultURL)
            : role?.type === "Admin"
              ? navigate("/admin-dashboard")
              : is_subscribe == 1 && singleTrust == 1
                ? navigate(`/trusts/${singleTrustId}/dashboard`)
                : isAMLSubscribe
                  ? navigate("/aml-ctf?tab=program")
                  : is_subscribe !== undefined && is_subscribe == 0
                    ? navigate("/general-settings?tab=subscription")
                    : navigate("/trusts");
        }
      } else {
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
    }
  };

  const handleBackToLogin = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <div
      className={`w-full lg:grid ${
        !change ? "min-h-screen lg:grid-cols-2" : ""
      }`}
    >
      {loading && <Spin full={true} />}
      {!change && <AuthLeftSide />}
      <div
        className={`flex items-center justify-center lg:h-auto  ${
          !change ? "min-h-screen" : ""
        } lg:flex-row flex-col`}
      >
        <LogoSVG className="lg:hidden fixed top-[15%] !text-webPrimary !fill-webPrimary h-28 w-full" />
        {useMethod ? (
          <div className="mx-auto grid w-[350px] gap-6">
            <div className="flex flex-col items-center justify-center gap-2 text-center">
              <Mail height={48} width={48} />
              <h1 className="text-3xl font-bold">Email Authentication</h1>
              <p className="text-balance text-muted-foreground">
                Enter the 6-digit code found in your email
              </p>
            </div>
            <Formik
              initialValues={{
                email: email ? email : "",
                code: "",
              }}
              validateOnBlur={false}
              validateOnChange={false}
              onKeyPress={(e) => {
                e.which === 13 && e.preventDefault();
              }}
              onSubmit={handleFinish}
            >
              {({
                values,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
              }) => (
                <form
                  onSubmit={handleSubmit}
                  className="row needs-validation"
                  noValidate
                >
                  <div className="grid gap-4">
                    <div className="flex items-center justify-center gap-2">
                      <InputOTP
                        maxLength={6}
                        onChange={(e) => setFieldValue("code", e)}
                        name="code"
                        onBlur={handleBlur}
                        value={values.code}
                      >
                        <InputOTPGroup>
                          <InputOTPSlot index={0} />
                          <InputOTPSlot index={1} />
                          <InputOTPSlot index={2} />
                        </InputOTPGroup>
                        <InputOTPSeparator />
                        <InputOTPGroup>
                          <InputOTPSlot index={3} />
                          <InputOTPSlot index={4} />
                          <InputOTPSlot index={5} />
                        </InputOTPGroup>
                      </InputOTP>
                    </div>
                    <Button type="submit" className="w-full">
                      Confirm
                    </Button>
                    <Button
                      type="reset"
                      variant="ghost"
                      className="w-full"
                      onClick={() => {
                        toggleUseMethod(setFieldValue);
                      }}
                    >
                      Use Another method
                    </Button>
                  </div>
                </form>
              )}
            </Formik>
            {!change && (
              <div className="mt-4 text-center text-sm">
                <Link to="/" className="underline" onClick={handleBackToLogin}>
                  Back to Login
                </Link>
              </div>
            )}
          </div>
        ) : (
          <div className="mx-auto grid w-[350px] gap-6">
            <div className="flex flex-col items-center justify-center gap-2 text-center">
              <div className="flex gap-1 items-center">
                <img
                  src={GoogleAuth}
                  height={70}
                  width={95}
                  alt="authenticator-logo"
                />
                <span className="pr-3">|</span>
                <img
                  src={MicroAuth}
                  height={70}
                  width={70}
                  alt="authenticator-logo"
                />
              </div>
              <h1 className="text-3xl font-bold">Authenticator App</h1>
              <p className="text-balance text-muted-foreground">
                Enter the 6-digit code found in your authenticator app
              </p>
            </div>
            <Formik
              initialValues={{
                email: email ? email : "",
                code: "",
              }}
              onKeyPress={(e) => {
                e.which === 13 && e.preventDefault();
              }}
              validateOnBlur={false}
              validateOnChange={false}
              onSubmit={handleFinish}
            >
              {({
                values,
                errors,
                handleChange,
                handleBlur,
                handleSubmit,
                setFieldValue,
              }) => (
                <form onSubmit={handleSubmit} className="row" noValidate>
                  <div className="grid gap-4">
                    <div className="flex items-center justify-center gap-2">
                      <InputOTP
                        maxLength={6}
                        onChange={(e) => setFieldValue("code", e)}
                        name="code"
                        id="code"
                        onBlur={handleBlur}
                        value={values.code}
                      >
                        <InputOTPGroup>
                          <InputOTPSlot index={0} />
                          <InputOTPSlot index={1} />
                          <InputOTPSlot index={2} />
                        </InputOTPGroup>
                        <InputOTPSeparator />
                        <InputOTPGroup>
                          <InputOTPSlot index={3} />
                          <InputOTPSlot index={4} />
                          <InputOTPSlot index={5} />
                        </InputOTPGroup>
                      </InputOTP>
                    </div>
                    <Button type="submit" className="w-full">
                      Confirm
                    </Button>
                    <Button
                      type="reset"
                      variant="ghost"
                      className="w-full"
                      onClick={() => toggleUseMethod(setFieldValue)}
                    >
                      Use Another method
                    </Button>
                  </div>
                </form>
              )}
            </Formik>
            {!change && (
              <div className="mt-4 text-center text-sm">
                <Link to="/" className="underline" onClick={handleBackToLogin}>
                  Back to Login
                </Link>
              </div>
            )}
          </div>
        )}
        <p className="lg:hidden fixed bottom-0 p-4 text-xs flex items-start gap-1 text-justify">
          <FaviconSVG className="h-5 w-5 !text-webPrimary !fill-webPrimary" />
          <span className="flex-1">
            TrustSoft acknowledges the Traditional Custodians of country
            throughout Australia and their connections to land, sea and
            community. We pay our respect to their Elders past and present and
            extend that respect to all Aboriginal and Torres Strait Islander
            peoples today.
          </span>
        </p>
      </div>
      <div className="fixed top-4 right-4">
        <ThemeToggle />
      </div>
    </div>
  );
};

export default TwoFactorAuth;
